import { AccuracyTemplateInspectionGroup } from "@app/templates/accuracy/models";

export function filterGenderAffirmingCareInspectionGroup(inspectionGroups: AccuracyTemplateInspectionGroup[], hideGenderAffirmingCare: boolean): AccuracyTemplateInspectionGroup[] {
    if (hideGenderAffirmingCare) {
        const filteredInspectiongroups = inspectionGroups.map((group) => {
            if (group.name === "Enrichment") {
                const filteredInspection = group.inspections.filter((inspection) => inspection.name !== 'Location Gender Affirming Care');
                return { ...group, inspections: filteredInspection };
            }
            return group;
        });
        return filteredInspectiongroups;
    }
    return inspectionGroups;
}